/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page3_MaterialsInputs */



/**
* | output |
* | --- |
* | "Equipment required for intervention" |
*
* @param {Intervention_Plan_Pdf_Page3_MaterialsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page3_materials = /** @type {((inputs?: Intervention_Plan_Pdf_Page3_MaterialsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page3_MaterialsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Equipment required for intervention")
	return /** @type {LocalizedString} */ ("Matériel requis pour intervention")
});